import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { sisenseClearState } from 'reducers/sisense/reducer'
import SisenseDashboardList from './SisenseDashboardList'
import SisenseDashboardItem from './SisenseDashboardItem'

function SisenseDashboard(props) {
  const {
    match: {
      params: { id },
    },
    sisenseClearState,
  } = props
  const SisenseDashboardContent = id
    ? SisenseDashboardItem
    : SisenseDashboardList

  useEffect(
    () => () => {
      sisenseClearState()
    },
    [],
  )

  return (
    <div className="content">
      <SisenseDashboardContent {...props} />
    </div>
  )
}

SisenseDashboard.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string,
    }),
  }).isRequired,
  sisenseClearState: PropTypes.func.isRequired,
}

export default connect(null, {
  sisenseClearState,
})(SisenseDashboard)
